export interface AtlAttributionData {
  atlWorkspaceId: string | null;
  tenantId: string | null;
  product: string;
  service: string;
}

const ATL_ATTRIBUTION_PRODUCT = 'Confluence Cloud';
const ATL_ATTRIBUTION_SERVICE_FE = 'micros/canvas-frontend';

let atlAttributionDataGetter: (() => AtlAttributionData | null) | null = null;

export function setAtlAttributionDataGetter(
  getter: (() => AtlAttributionData | null) | null,
): void {
  atlAttributionDataGetter = getter;
}

export function getAtlAttributionData(): AtlAttributionData | null {
  return atlAttributionDataGetter?.() ?? null;
}

export function buildWorkspaceAri(
  cloudId: string | null | undefined,
  activationId: string | null | undefined,
): string | null {
  if (!cloudId || !activationId) {
    return null;
  }
  return `ari:cloud:confluence:${cloudId}:workspace/${activationId}`;
}

/**
 * Builds the Atl attribution header. See
 * https://hello.atlassian.net/wiki/spaces/AGG/pages/5954141702/Metrics+Attribution+Onboarding+Doc+for+AGG+Clients#Are-you-a-FE-Client-to-AGG%3F
 * for more details.
 * @param activationId - The activation ID of the workspace
 * @param cloudId - The cloud ID (tenant ID) of the workspace
 * @returns The Atl attribution header
 */
export function buildAtlAttributionHeader(
  activationId: string | null | undefined,
  cloudId: string | null | undefined,
): string {
  const attribution: AtlAttributionData = {
    atlWorkspaceId: buildWorkspaceAri(cloudId, activationId),
    tenantId: cloudId ?? null,
    product: ATL_ATTRIBUTION_PRODUCT,
    service: ATL_ATTRIBUTION_SERVICE_FE,
  };

  return JSON.stringify(attribution);
}
